import { getTenant, getUserName } from '../helpers';
import { api } from './api';

export function getRecommendedCoursesAPI(search, callback, limit = 12, offset = "", isProgram=false, useTenant=false) {
  const tenant = getTenant()
  const queryParam = new URLSearchParams(<any>{
    ...(useTenant ? {
      tenant:tenant
    } : {} ),
    content:isProgram ? "programs" : "courses",
    ...(offset ? {
      offset:offset
    } : {}),
    limit,
    ...(search ? {
      query:encodeURIComponent(search),
    } : {})
  }).toString()
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/search/personalized-catalog/${getUserName()}/?${queryParam}`;
  return fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => {
      callback(data?.results ?? []);
    })
    .catch((error) => {
      console.error('Error fetching courses:', error);
      callback([]);
    });
}

function filterRecommendedCourseData(data, callback) {
  const recommendedCourses = [];
  if ( data?.courses && Array.isArray(data?.courses)){
    for (let i = 0; i < data.courses.length && i < 5; i++) {
      const course = data.courses[i];
      recommendedCourses.push(course);
    }

  }

  callback(recommendedCourses);
}
